import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'z-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingOverlayComponent implements OnDestroy, AfterViewInit {
  @Input() target: string;
  @Input() styleClass: string;

  @Input() width: string = '100%';
  @Input() height: string = '100%';
  @Input() size: string;

  @Input() get blocked(): boolean {
    return this._blocked;
  }

  set blocked(val: boolean) {
    this._blocked = val;

    setTimeout(() => {
      if (val) {
        this.block();
      } else {
        this.unblock();
      }
    }, 0);
  }

  @ViewChild('mask') mask: ElementRef<HTMLDivElement>;

  _target: HTMLElement;
  _parent: HTMLElement;
  _blocked: boolean;

  constructor(public elementRef: ElementRef, public changeDetector: ChangeDetectorRef) {}

  ngOnDestroy() {
    this.unblock();
  }

  ngAfterViewInit() {
    setTimeout(() => this.attach(), 0);
  }

  attach() {
    if (this._target && this._parent) {
      return;
    }

    this._target = document.querySelector(`.${this.target}`);

    if (this._target) {
      this._parent = this._target.parentElement;

      if (this._parent) {
        this._parent.style.position = 'relative';
        this._parent.appendChild(this.mask.nativeElement);
      }

      if (this.size === 'auto') {
        this.width = `${this._target.offsetWidth}px`;
        this.height = `${this._target.offsetHeight}px`;
      }
    }
  }

  block() {
    if (this._target) {
      if (this.size === 'auto') {
        this.width = `${this._target.offsetWidth}px`;
        this.height = `${this._target.offsetHeight}px`;
      }
    }

    if (!this._target || !this._parent) {
      this.attach();
    }

    this._blocked = true;
    this.changeDetector.markForCheck();
  }

  unblock() {
    if (!this._target || !this._parent) {
      this.attach();
    }

    this._blocked = false;
    this.changeDetector.markForCheck();
  }
}
